export default defineNuxtPlugin((nuxtApp) => {
    const allowedForwardedHeaders = [
        "cookie",
        "user-agent",
        "accept-language",
        "referer",
        "x-forwarded-for",
        "x-real-ip"
    ]

    const requestEvent = useRequestEvent();
    const requestHeaders = useRequestHeaders(allowedForwardedHeaders) as Record<string, string>;
    const getLocaleQueryValue = (localeQuery: unknown) => {
        const value = Array.isArray(localeQuery) ? localeQuery[0] : localeQuery;
        return value?.toString();
    }

    const siteFetch = $fetch.create({
        baseURL: import.meta.server ? '/api/site-proxy' : undefined,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-Nuxt-Request-From': import.meta.server ? "server" : "client",
            ...requestHeaders
        },
        onRequest: ({ options }) => {
            const route = useRoute();
            const localeQuery = route.query?.locale;
            if (localeQuery) {
                const localeStore = useLocaleStore();
                const normalizedLocale = localeStore.getShippableLocale?.(getLocaleQueryValue(localeQuery))?.localeCode
                    ?? localeStore.locale?.localeCode
                    ?? 'en-US';
                const params = (options.params as Record<string, unknown>) ?? {};
                options.params = { ...params, locale: normalizedLocale };
            }
            if (!!requestEvent) {
                let responseCookies = requestEvent.node.res.getHeader('Set-Cookie');
                if (!!responseCookies && typeof responseCookies !== 'number') {
                    if (typeof responseCookies === 'string') {
                        responseCookies = [responseCookies];
                    }
                    responseCookies.forEach((val) => options.headers.append('cookie', val));
                }
            }
        },
        onResponse: ({ response }) => {
            if (!!requestEvent) {
                const setCookieHeaders = response.headers.getSetCookie();
                setCookieHeaders.forEach(cookie => requestEvent.node.res.appendHeader('Set-Cookie', cookie));
            }
        }
    });

    // Expose to useNuxtApp().$siteFetch
    return {
        provide: {
            siteFetch
        }
    }
})
